import moment from 'moment'

export const data = function() {
  return {
    isDebug: true,
    loading: false,
    toggle: false,
    formData: {
      federalTaxId: '',
      assessments: '',
      lateFees: '',
      closingFees: '',
      parcelTaxNumbers: ''
    },
    financialInformation: null,
    styles: {
      mainContainer: {
        minHeight: '1000px'
      }
    },
    formatDateFn: function(value) {
      return value != null
        ? moment(value, 'YYYY/MM/DD HH:mm:ss').format('MM-DD-YYYY hh:mm:ss a')
        : ''
    }
  }
}
